import PropTypes from 'prop-types';
import React from 'react';

import { useHotkey } from './hooks';
import HotkeyPropType from '../../prop-types/hotkey';

const HotkeyComponent = ({ children = null, hotkey }) => {
  useHotkey(hotkey);

  return <React.Fragment>{children}</React.Fragment>;
};

HotkeyComponent.propTypes = {
  children: PropTypes.node,
  hotkey: HotkeyPropType,
};

export default HotkeyComponent;
